import template from './list.html';
import * as AccountsActions from '../../../state/accounts/accounts.actions';

export class AccountListController {
  constructor($scope, $ngRedux) {
    'ngInject';

    this.scope = $scope;
    this.store = $ngRedux;
    this.mapStateToThis = this.mapStateToThis.bind(this);
    this.unsubscribe = this.store.connect(this.mapStateToThis, AccountsActions)(this);
    this.query = '';
    this.exactMatch = false;
    this.selectedIndex = null;
  }

  $onDestroy() {
    this.unsubscribe();
  }

  mapStateToThis(state) {
    this.filteredAccounts = this.filterAccountNames(state.accounts.subaccounts).map((account) => {
      account.loading = account.id === state.accounts.loading_account;
      return account;
    });

    return {
      viewing: state.accounts.viewing_account,
      creating: state.accounts.creating_subaccount,
      accounts: state.accounts.subaccounts,
    };
  }

  updateAccountFilter() {
    this.filteredAccounts = this.filterAccountNames(this.accounts);
    window.dataLayer.push({
      event: 'subaccountsFiltered',
      data: {
        total: this.accounts.length,
        totalFiltered: this.filteredAccounts.length,
        exactMatch: this.exactMatch,
      },
    });
  }

  filterAccountNames(accounts) {
    this.exactMatch = false;

    if (!this.query || this.query === '') {
      return [...accounts];
    }

    let filteredAccounts = accounts.filter((account) => {
      if (account.name.toLowerCase() === this.query.toLowerCase()) this.exactMatch = true;
      return account.name.toLowerCase().includes(this.query.toLowerCase());
    });

    return filteredAccounts;
  }

  createNewSubAccount() {
    this.createSubAccount(this.query);
    this.query = '';
  }

  selectAccount(index) {
    this.selectedIndex = index;
    let account = this.filteredAccounts[index];
    this.getAccount(account.id);
  }
}

export default {
  template,
  replace: true,
  controller: AccountListController,
  controllerAs: 'vm',
};
